import GenericGridCreator from 'ps-components/AdvancedTable/GenericGrid/GenericGridCreator';
import React from 'react';

const JOB_EMPLOYEES_PAGE_LIST = 'JOB_EMPLOYEES_PAGE_LIST';

const EmployeeIDColumn = rowData => {
  const employeeId = rowData.field_employee_number;
  const { subsite } = window.app;

  return (
    <a
      className="job-employee__id"
      href={`${window.location.origin}/view/o/${subsite}/mp/iframe/merit/hris/employee/employees?initial_employee_number=${employeeId}`}
      target="_blank"
    >
      {employeeId}
    </a>
  );
};

const newGenericGrid = new GenericGridCreator(
  'JOB_EMPLOYEES',
  {},
  {
    addedFilters: [],
    defaultLeftColumns: [
      {
        Header: 'Employee ID',
        stickyLeft: true,
        customRender: EmployeeIDColumn,
        accessor: null,
        width: 80
      }
    ],
    hiddenTerms: ['field_employee_number'],
    limit: 50,
    orderBy: [],
    tableProps: {
      useSelectAll: false
    }
  },
  {
    getInstanceState: store => {
      store.jobEmployees.jobEmployeesGridReducer;
    }
  }
);
export const jobEmployeesGridActions = newGenericGrid.getActions();

jobEmployeesGridActions.pageList = (limit, offset) => {
  return dispatch => {
    return dispatch({
      type: JOB_EMPLOYEES_PAGE_LIST,
      limit,
      offset
    });
  };
};

function extendReducer(state, action) {
  switch (action.type) {
    case JOB_EMPLOYEES_PAGE_LIST:
      return {
        ...state,
        limit: action.limit,
        offset: action.offset
      };
    default:
      return null;
  }
}
export default newGenericGrid.createReducer(extendReducer);
